import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SharedService } from './shared.service';

@Injectable()
export class GoogleAnalytics {

  private jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  private pdfOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/pdf')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) { }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   *
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      console.error(error); // log error to console

      // Let the app keep running by returning an empty result.
      return of(error as T);
    };
  }

  public getUniqueNumber(): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'session/google/tags/number/id', this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getBooking', []))
    );
  }
}
